import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { CommentListComponent } from '../../home/comment-list/comment-list.component';
import { UploaderComponent } from '../../home/uploader/uploader.component';
import { AuditTrailComponent } from '../../software/audit-trail/audit-trail.component';
import { BaseListComponent } from '../base-list/base-list.component';
import { FormComponent } from '../form/form.component';
import { environment } from '../../../../environments/environment';
import { AudioPlayerComponent } from '../audio-player/audio-player.component';

@Component({
  selector: 'app-list',
  templateUrl: '../base-list/base-list.component.html',
  styleUrls: ['./list.component.scss', '../base-list/base-list.component.scss']
})
export class ListComponent extends BaseListComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.form = FormComponent;
  }

  async ngOnInit() {
    if (this.route.snapshot.url.length) {
      this.route.params.subscribe(async params => {
        this.columns = [];
        this.actions = [];
        this.filter = { query: null };
        if (params) {
          this.handleParams(params);
        }
        await super.ngOnInit();
      });
    } else {
      await super.ngOnInit();
    }
  }

  handleParams(params) {
    this.params = params;
    this.title = params.entity || this.title;
    this.entity = params.entity || this.entity;
    this.subentity = params.subentity || this.subentity;
  }

  async perform(action, row) {
    return new Promise(async (resolve, reject) => {
      try {
        let modal;
        switch (action.name.toLowerCase()) {
          case 'audit_trail':
            const auditTrailList = this.activeModal.open(AuditTrailComponent, { size: 'xl' });
            auditTrailList.componentInstance.base = this.entity;
            auditTrailList.componentInstance.ref = row[this.pkey];
            break;
          case 'comments':
            modal = this.activeModal.open(CommentListComponent, { size: 'lg' });
            modal.componentInstance.base = this.entity;
            modal.componentInstance.ref = row[this.pkey];
            break;
          case 'attachments':
            modal = this.activeModal.open(UploaderComponent, { size: 'lg' });
            modal.componentInstance.selectedRows = row;
            modal.componentInstance.pkey = this.pkey;
            modal.componentInstance.path = this.entity.toLowerCase();
            break;
          case 'listen':
            if (!row.audioUrl){
              const result = await this.service.perform(this.entity, action.name, row).toPromise();
              if (result.redirectUrl) {
                row.audioUrl = `${environment.url}${result.redirectUrl}`
              }
            }

            if (row.audioUrl){
              const audioPlayer = this.activeModal.open(AudioPlayerComponent)
              audioPlayer.componentInstance.audioUrl = row.audioUrl
            }
            break;
          default:
            await super.perform(action, row);
            resolve(true);
        }
      } catch (error) {
        reject(error);
      }
    });
  }

}
